import React, { useEffect, useState } from "react";
import { faFloppyDisk, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InventryGeneralTab from "./InventryGeneralTab";
import {
  IPharmaInventory,
  IPharmaInventoryCreate,
} from "src/types/GlobalInterfaces";
import InventryOverviewTab from "./InventryOverviewTab";
import InventoryPriceTab from "./InventoryPriceTab";
import InventoryCategoriesTab from "./InventoryCategoriesTab";
import InventoryImagesTab from "./InventoryImagesTab";
import { toast } from "react-toastify";
import httpRequest from "src/helpers/httpRequest";
import InventoryTagsTab from "./InventoryTagsTab";
import InventoryLinkTab from "./InventoryLinkTab";
import InventoryFrequenltyBoughtTab from "./InventoryFrequenltyBoughtTab";

interface IProps {
  isEdit: IPharmaInventory | null;
  onSuccess: () => void;
}

const UpsertPharmaInventory: React.FC<IProps> = ({
  isEdit = null,
  onSuccess = () => {},
}) => {
  const tabsArray: string[] = [
    "general",
    "overview",
    "price",
    "tags",
    "frequently bought together",
    "links",
    "categories",
    "image",
  ];
  const [activeTab, setActiveTab] = useState<string>("general");
  const [localProduct, setLocalProduct] = useState<IPharmaInventory[]>([]);
  const handleTabClick = (tabName: string) => {
    setActiveTab(tabName);
  };

  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [payload, setPayload] = useState<IPharmaInventoryCreate>({
    _id: isEdit?._id || "",
    productName: "",
    brandId: "",
    quantity: "",
    shortDescription: "",
    overview: "",
    regularPrice: "",
    salePrice: "",
    mainCategoryId: "",
    subCategoryId: "",
    childCategoryId: "",
    galleryImages: ["", "", ""],
    image: null,
    prescriptionRequired: false,
    sku: "",
    deliveryType: "",
    productDetails: "",
    promotionalTag: "",
    productTags: [],
    links: [],
    frequentlyBoughtTogether: [],
    salesBanners: [],
    promotionalTagName: null,
    productTagsName: [],
  });

  // Function to handle changes in form fields
  const handleChange = (
    key: keyof IPharmaInventoryCreate,
    val: any
  ) => {
    setPayload((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const handleSubmit = async () => {
    const {
      productName,
      brandId,
      quantity,
      shortDescription,
      overview,
      regularPrice,
      salePrice,
      mainCategoryId,
      subCategoryId,
      childCategoryId,
      image,
      galleryImages,
      prescriptionRequired,
      sku,
      promotionalTag,
      productTags,
      links,
      salesBanners,
      deliveryType,
      frequentlyBoughtTogether,
      productDetails,
      productTagsName,
      promotionalTagName
    } = payload;

    let GM = galleryImages.filter((item) => item !== "" && item !== null);
    // Validate required fields
    if (!productName || !brandId || !quantity || !overview) {
      toast("Please fill out all general details before proceeding.", {
        type: "error",
      });
      setActiveTab("general");
      return;
    } else if (!overview) {
      toast(
        "The overview section cannot be empty. Please provide a description.",
        { type: "error" }
      );
      setActiveTab("overview");
      return;
    } else if(!productDetails) {
      toast("Please provide the product details.", { type: "error" });
      setActiveTab("overview");
      return;
    } else if (!regularPrice) {
      toast("Please specify the regular price of the product.", {
        type: "error",
      });
      setActiveTab("price");
      return;
    } else if (Number(salePrice || 0) >= Number(regularPrice)) {
      toast(
        "Sale price cannot be greater than or equal to the regular price.",
        { type: "error" }
      );
      setActiveTab("price");
    } else if (!mainCategoryId || !subCategoryId || !childCategoryId) {
      toast("Ensure that all category fields are selected.", { type: "error" });
      setActiveTab("categories");
      return;
    } else if (!image) {
      toast("A main image is required to proceed. Please upload one.", {
        type: "error",
      });
      setActiveTab("image");
      return;
    } else if (
      GM?.length < 3 ||
      !GM.every(
        (image) => image && (typeof image === "string" || image instanceof File)
      )
    ) {
      console.log("Gallery Images ===> ", GM);
      toast("Please upload at least 3 images for the product gallery.", {
        type: "error",
      });
      setActiveTab("image");
      return;
    } else {
      setIsLoader(true);
      const formData = new FormData();
      formData.append("productName", productName);
      formData.append("brandId", brandId);
      formData.append("quantity", quantity);
      formData.append("sku", sku);
      // formData.append("shortDescription", shortDescription);
      formData.append("productDetails", productDetails);
      formData.append("overview", overview);
      formData.append("regularPrice", regularPrice);
      formData.append("salePrice", salePrice || "");
      formData.append("promotionalTag", promotionalTag);
      formData.append("mainCategoryId", mainCategoryId);
      formData.append("subCategoryId", subCategoryId);
      formData.append("childCategoryId", childCategoryId);
      formData.append("deliveryType", deliveryType);
      formData.append("prescriptionRequired", String(prescriptionRequired));
      links?.map((item) => {
        formData.append("links", item);
      });
      // productTags?.map((item) => {
      // });
      formData.append("productTags", JSON.stringify(productTags));
      productTagsName?.map((item) => {
        formData.append("productTagsName", item);
      });
      // formData.append("productTagsName", JSON.stringify(productTagsName) || "");
      formData.append("promotionalTagDetails", JSON.stringify(promotionalTagName) || "");
      formData.append("frequentlyBoughtTogether", JSON.stringify(frequentlyBoughtTogether));
      // frequentlyBoughtTogether?.map((item) => {
      //   formData.append("frequentlyBoughtTogether", JSON.stringify(item));
      // });
      formData.append("image", image);
      if(salesBanners.length > 0){
        salesBanners?.forEach((bannerImage) => {
          if (bannerImage !== "" && bannerImage !== undefined && bannerImage) {
            formData.append("salesBanners", bannerImage);
          }
        });
      }
      if (isEdit) {
        GM.forEach((image) => {
          if (image instanceof File) {
            formData.append("galleryImages", image);
          } else if (typeof image === "string") {
            formData.append("galleryImagesUrl", image);
          }
        });
        // salesBanners?.map;
      } else {
        GM.forEach((image, index) => {
          if (image) {
            formData.append(`galleryImages`, image);
          }
        });
      }
      const path = isEdit
        ? `/pharma-inventory/edit/${isEdit._id}`
        : "/pharma-inventory/create";
      const { res, err } = await httpRequest<any>({
        method: isEdit ? "put" : "post",
        path,
        params: formData,
        header: { "Content-Type": "multipart/form-data" },
      });
      if (res) {
        toast(
          `Inventory ${isEdit ? "updated" : "added"} successfully.`,
          { type: "success" }
        );
        onSuccess();
        setPayload({
          _id: "",
          productName: "",
          brandId: "",
          quantity: "",
          shortDescription: "",
          overview: "",
          regularPrice: "",
          salePrice: "",
          mainCategoryId: "",
          subCategoryId: "",
          childCategoryId: "",
          galleryImages: ["", "", ""],
          image: null,
          prescriptionRequired: false,
          sku: "",
          deliveryType: "",
          productDetails: "",
          promotionalTag: "",
          productTags: [],
          links: [],
          frequentlyBoughtTogether: [],
          salesBanners: [],
          promotionalTagName: null,
          productTagsName: [],
          });
      } else {
        toast(err, { type: "error" });
      }
      setIsLoader(false);
    }
  };

  useEffect(() => {
    if (isEdit && typeof isEdit !== "boolean") {
      let {
        _id = "",
        productName = "",
        brandId = "",
        quantity = 0,
        shortDescription = "",
        overview = "",
        regularPrice,
        salePrice,
        mainCategoryId,
        subCategoryId,
        childCategoryId,
        images = "",
        galleryImages = [],
        prescriptionRequired,
        sku,
        deliveryType,
        productDetails,
        promotionalTag,
        productTags,
        links,
        salesBanners,
        frequentlyBoughtTogether,
        promotionalTagName,
        productTagsName,
      } = isEdit;

      setPayload({
        _id,
        productName,
        brandId,
        quantity: String(quantity),
        shortDescription,
        overview,
        regularPrice: String(regularPrice),
        salePrice: String(salePrice),
        mainCategoryId,
        subCategoryId,
        childCategoryId,
        image: images,
        galleryImages,
        prescriptionRequired,
        sku,
        deliveryType,
        productDetails,
        promotionalTag,
        productTags,
        links,
        frequentlyBoughtTogether,
        salesBanners,
        promotionalTagName,
        productTagsName,
      });
    }
  }, [isEdit]);

  return (
    <div className="relative">
      <button
        className="absolute save-pharmacy-and-product border-[#333] border rounded"
        disabled={isLoader}
        onClick={handleSubmit}
        id="save-pharma-inventory-btn"
      >
        <FontAwesomeIcon
          spin={isLoader}
          className="text-sm"
          icon={isLoader ? faSpinner : faFloppyDisk}
        />
      </button>
      <div className="products-tabs-btn">
        {tabsArray.map((item: string) => (
          <button
            key={item}
            className={`font-size-15px font-Poppins-Medium capitalize ${
              activeTab === item ? "active" : ""
            }`}
            onClick={() => handleTabClick(item)}
            id={`pharma-inventory-tab-btn-${item}`}
          >
            {item}
          </button>
        ))}
      </div>
      <hr
        className="products-tabs-hr"
        style={{ border: "1px solid #D4D4D4" }}
      />
      <div className="parent-box-scroll-bar-product">
        {activeTab === "general" ? (
          <div className="products-tabs-content-main">
            <InventryGeneralTab
              state={payload}
              setState={handleChange}
              tabChange={() => handleTabClick("overview")}
              tooglePrescription={() =>
                setPayload((prev) => ({
                  ...prev,
                  prescriptionRequired: !prev?.prescriptionRequired,
                }))
              }
            />
          </div>
        ) : activeTab === "overview" ? (
          <div className="products-tabs-content-main">
            <InventryOverviewTab
              state={payload}
              setState={handleChange}
              tabChange={() => handleTabClick("price")}
            />
          </div>
        ) : activeTab === "price" ? (
          <div className="products-tabs-content-main">
            <InventoryPriceTab
              state={payload}
              setState={handleChange}
              tabChange={() => handleTabClick("tags")}
            />
          </div>
        ) : activeTab === "tags" ? (
          <div className="products-tabs-content-main">
            <InventoryTagsTab
              state={payload}
              setState={handleChange}
              tabChange={() => handleTabClick("frequently bought together")}
            />
          </div>
        ) : activeTab === "frequently bought together" ? (
          <div className="products-tabs-content-main !w-full">
            <InventoryFrequenltyBoughtTab
              state={payload}
              setState={handleChange}
              tabChange={() => handleTabClick("links")}
              setLocalProduct={(data) => {
                console.log("data ===> ", data);
                let lastData = localProduct.filter((item) => item._id !== data._id);
                lastData = lastData.concat(data);
                console.log("lastData ===> ", lastData);
                setLocalProduct(lastData);
              }}
              localProduct={localProduct}
            />
          </div>
        ) : activeTab === "links" ? (
          <div className="products-tabs-content-main">
            <InventoryLinkTab
              state={payload}
              setState={handleChange}
              tabChange={() => handleTabClick("categories")}
            />
          </div>
        ) : activeTab === "categories" ? (
          <div className="products-tabs-content-main">
            <InventoryCategoriesTab
              state={payload}
              setState={handleChange}
              tabChange={() => handleTabClick("image")}
            />
          </div>
        ) : activeTab === "image" ? (
          <div className="products-tabs-content-main">
            <InventoryImagesTab
              state={payload}
              setState={setPayload}
              tabChange={() => handleTabClick("categories")}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default UpsertPharmaInventory;
